import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {OverlayModule} from '../../overlay';
import {L10nModule} from '../../translate';
import {WidgetLinkingGroupDropdownComponent} from './widget-linking-group-dropdown';
import {WidgetLinkingGroupPickerComponent} from './widget-linking-group-picker.component';

@NgModule({
    imports: [
        L10nModule,
        CommonModule,
        OverlayModule
    ],
    declarations: [
        WidgetLinkingGroupDropdownComponent,
        WidgetLinkingGroupPickerComponent
    ],
    exports: [
        WidgetLinkingGroupPickerComponent,
        WidgetLinkingGroupDropdownComponent
    ]
})
export class WidgetLinkingGroupPickerModule {}
